import styled from "styled-components";

interface StickyInputProps {
	prefixSize: number;
	hiddenLabel: boolean;
}

export const StickyInput = styled.div<StickyInputProps>`
	position: relative;
	p.mask {
		position: absolute;
		left: 10px;
		top: ${({ hiddenLabel }) => (hiddenLabel ? "8px" : "27px")};
		z-index: 2;
		pointer-events: none;
		letter-spacing: normal;
		font-weight: 400;
		color: rgba(0, 0, 0, 0);
		display: flex;
		width: calc(100% - 20px);
		overflow: hidden;
		.prefix,
		.suffix {
			color: #9b9b9b;
		}
		.show {
			color: #0876e8;
		}
	}

	input {
		padding-left: ${({ prefixSize }) => `${prefixSize + 10}px`} !important;
	}
`;
